import type { InvitationPayload } from '@Application/Security/Invitations/Actions/invitationFetched';
import InvitationSummary from '@UI/Pages/Authentication/Invitation/Shared/InvitationSummary';
import * as React from 'react';
import { Message } from '@verclam/ui-kit';

type Props = {
	readonly invitation: InvitationPayload;
};

/**
 * `signInMethod: 'unavailable'` (§8.5): the account is stuck between an exclusive fournisseur and a
 * `password` mode it was never switched out of. Neither action would ever succeed — the server refuses
 * a password (`422`) and the SSO callback refuses the account — so no button is shown at all, only the
 * orientation message telling this person who can fix it.
 */
const InvitationUnavailable: React.FC<Props> = ({ invitation }) => {
	return (
		<React.Fragment>
			<InvitationSummary
				organizationNames={invitation.organizationNames}
				roleLabel={invitation.roleLabel}
				facilityNames={invitation.facilityNames}
			/>
			<Message
				severity="warn"
				text={
					"Votre structure impose la connexion par son fournisseur d'identité, mais votre compte est " +
					'configuré pour un mot de passe. Contactez votre administrateur.'
				}
			/>
		</React.Fragment>
	);
};

export default InvitationUnavailable;
